<template>
  <div class="container-fluid avatar-generator" v-if="avatars.length && avatarShoes.length">
    <div class="row">
      <div class="col-8">
        <div class="row avatar-generator-shoe-wrapper">
          <top-navigation :show-home="false" :show-back="false" :show-avatar="false" :on-top="true"></top-navigation>
          <div class="col-2 next-shoe middle" @click="prev(avatarShoes, 'selectedAvatarShoe')">
            <button class="round-button">
              <i class="fas fa-chevron-left transparent"></i>
            </button>
          </div>
          <div class="col-8 shoe-wrapper-bg" :style="bgShoe(avatarShoes[selectedAvatarShoe].meta.shoe_image)">
            <h3 class="shoe-title">CHOOSE YOUR EXPLORER <span class="orange">SHOES.</span></h3>
            <div class="shoe-descr">
              <div class="name text-center">
                {{ avatarShoes[selectedAvatarShoe].post_title }}
              </div>
            </div>
          </div>
          <div class="col-2 prev-shoe middle" @click="next(avatarShoes, 'selectedAvatarShoe')">
            <button class="round-button">
              <i class="fas fa-chevron-right transparent"></i>
            </button>
          </div>
        </div>
        <div class="row avatar-shoes">
          <div class="col-12">
            <div class="avatar-shoes-wrapper">
              <div ref="avatarShoes" class="avatar-shoe" :class="{'active-shoe': index === selectedAvatarShoe }" :key="index" v-for="(avatarShoe, index) in avatarShoes" @click="selectedAvatarShoe = index">
                <img :src="avatarShoe.meta.animal_image"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4 avatar-generator-bg">
        <h3>CHOOSE YOUR NAME AND AVATAR</h3>
        <div class="avatar-generator-wrapper">
          <div class="row">
            <div class="col-4">
              <roll :list="avatarNames.adjectives" :selected.sync='selectedAvatarAdjective'></roll>
            </div>
            <div class="col-4">
              <roll :list="avatarNames.animals" :selected.sync='selectedAvatarAnimal'></roll>
            </div>
            <div class="col-4">
              <div class="roll avatar-face row text-center p-2">
                <div class="col-12 p-0 up">
                  <button class="select-button top" @click="prev(avatars, 'selectedAvatar')">
                    <i class="fas fa-chevron-up"></i>
                  </button>
                </div>
                <div class="col-12 p-0 display text-center middle">
                  <img :src="avatars[selectedAvatar].thumbnail"/>
                </div>
                <div class="col-12 p-0 down">
                  <button class="select-button bottom" @click="next(avatars, 'selectedAvatar')">
                    <i class="fas fa-chevron-down"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="shuffle text-center">
            <button @click="shuffle()">SHUFFLE</button>
          </div>
          <div class="done text-center">
            <button class="btn btn-primary mx-auto ng-default-btn mx-auto" @click="done()">DONE</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import scrollToElement from 'scroll-into-view-if-needed'
import avatarNames from '../assets/avatarNames'
import Roll from '../components/Roll'
import TopNavigation from '../components/TopNavigation'

export default {
  name: 'AvatarGenerator',
  components: {
    Roll,
    TopNavigation
  },
  data () {
    return {
      selectedAvatar: 0,
      selectedAvatarShoe: 0,
      avatarName: '',
      avatarNames,
      selectedAvatarAdjective: 0,
      selectedAvatarAnimal: 0,
      avatarAnimal: 0
    }
  },
  mounted () {
    if (this.userName.length) {
      this.$router.push('/loading')
    } else {
      this.loadAvatars()
    }
  },
  methods: {
    ...mapActions(['loadAvatars', 'setUser']),
    shuffle () {
      this.selectedAvatar = Math.floor(Math.random() * (this.avatars.length))
      this.selectedAvatarShoe = Math.floor(Math.random() * (this.avatarShoes.length))
      this.selectedAvatarAdjective = Math.floor(Math.random() * (this.avatarNames.adjectives.length))
      this.selectedAvatarAnimal = Math.floor(Math.random() * (this.avatarNames.animals.length))
    },
    next (list, selected) {
      if (list[this[`${selected}`] + 1] !== undefined) {
        this[`${selected}`]++
      } else {
        this[`${selected}`] = 0
      }
    },
    prev (list, selected) {
      if (list[this[`${selected}`] - 1] !== undefined) {
        this[`${selected}`]--
      } else {
        this[`${selected}`] = list.length - 1
      }
    },
    done () {
      this.$router.push('/loading')
      this.setUser({
        avatar: {
          selectedAvatar: this.avatars[this.selectedAvatar].ID,
          selectedAvatarShoe: this.avatarShoes[this.selectedAvatarShoe].ID,
          avatarImage: this.avatars[this.selectedAvatar].featuredImage,
          avatarShoes: {
            animalImage: this.avatarShoes[this.selectedAvatarShoe].meta.animal_image,
            shoeImage: this.avatarShoes[this.selectedAvatarShoe].meta.shoe_image,
            avatarShoeImage: this.avatarShoes[this.selectedAvatarShoe].meta.avatar_shoe_image
          }
        },
        userName: this.avatarNames.adjectives[this.selectedAvatarAdjective] + ' ' + this.avatarNames.animals[this.selectedAvatarAnimal]
      }).then(state => {
        if (state) {
          this.$router.push('/loading')
        }
      })
    },
    bgShoe (img) {
      return { backgroundImage: 'url("' + img + '")' }
    }
  },
  computed: {
    ...mapGetters(['avatars', 'avatarShoes', 'userName'])
  },
  watch: {
    selectedAvatarShoe (pos) {
      scrollToElement(this.$refs.avatarShoes[pos], {
        scrollMode: 'always',
        block: 'nearest',
        inline: 'nearest',
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
  .avatar-generator h3 {
    text-align: center;
    font-size: 3.5vh;
    color: #ffffff;
    font-family: "Geograph-Bold";
    text-shadow: 0px 3px 2px rgba(0, 0, 0, 0.8);
    padding-top: 3vh;
  }

  .avatar-generator-bg {
    height: 100vh;
    background-image: url("../assets/img/bgsplash.jpg");
    background-size: cover;
    background-position: center;
  }

  .avatar-generator-shoe-wrapper {
    height: 80vh;
  }

  .avatar-generator-img-wrapper {
    padding-top: 2vh;
  }

  .avatar-img img {
    width: 10vw;
    height: 10vw;
  }

  .name-selector {
    padding-top: 10px;
    color: #ffbf00;
    font-family: "Geograph-Bold";
    font-size: 2vw;
    text-shadow: 0px 3px 2px rgba(0, 0, 0, 0.8);
    text-transform: uppercase;
    text-align: center;
  }

  .name-selector input {
    margin-top: 5%;
    background-color: transparent;
    border: none;
    color: #fae244;
    font-size: 2vw;
    text-align: center;
    font-family: "Geograph-Bold";
  }

  .name-selector input::placeholder {
    color: #fae244;
    opacity: 0.5;
  }

  .name-selector input:focus {
    outline-color: #fae244;
  }

  .shuffle {
    margin-top: 5vh;
  }

  .shuffle button {
    width: 50%;
    font-family: "Geograph-Bold";
    border-width: 4px;
    padding: 10px;
    background-color: #298c7a;
    color: #ffffff;
    font-size: 1vw;
    border-radius: 10px;
    border-color: #fae244;
    border-style: solid;
  }

  .done, .shoe {
    padding-top: 10%;
  }

  .done button {
    width: 80%;
  }

  .shoe img {
    max-height: 60vh;
    max-width: 100%;
  }

  .shoe-animals {
    height: 20vh;
  }

  .avatar-shoe {
    float: left;
    background-color: #fff;
  }

  .avatar-shoe img {
    height: 20vh;
  }

  .avatar-shoes {
    background-color: #000;
    height: 20vh;
    overflow: hidden;
  }

  .avatar-shoes-wrapper {
    height: 20vh;
  }

  .avatar-shoe img {
    opacity: 0.5;
  }

  .avatar-shoe.active-shoe img {
    opacity: 1;
  }

  .shop a {
    color: #989898;
    text-decoration: underline;
    font-size: 1.8vw;
  }

  .name {
    font-family: "Geograph-Black";
    font-size: 2vw;
  }

  .prev-shoe {
    position: relative;
    z-index: 99;
  }

  .next-shoe {
    position: relative;
    z-index: 99;
  }

  .shoe-wrapper-bg {
    background-position: center;
    background-size: 150%;
  }

  .shoe-descr {
    position: absolute;
    bottom: 2%;
    width: 100%;
    color: #fff;
  }

  .shoe-title {
    text-shadow: none !important;
    margin-left: auto;
    margin-right: auto;
    padding-top: 3vh;
    width: 50%;
  }

  .avatar-selector {
    display: flex;
    width: 100%;
  }

  .avatar-arrow {
    flex-direction: column;
    justify-content: center;
    display: flex;
  }

  .avatar-generator-bg {
    display: flex;
    flex-direction: column;
  }

  .avatar-generator-wrapper {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    display: flex;
    height: 80vh;
  }

  .avatar-face .display {
    background: #ffffff;
  }

  .avatar-face img {
    width: 7vw;
    height: 7vw;
  }
</style>
